var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { HubTour } from '../../../../models/hub/hub.tour';
import { ImageService } from '../../../../services/image.service';
var VisitorTourCardComponent = /** @class */ (function (_super) {
    __extends(VisitorTourCardComponent, _super);
    function VisitorTourCardComponent(router, activatedRoute, imageService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.imageService = imageService;
        _this.isShowDescription = false;
        _this.isLoading = false;
        _this.titleBgColor = '#23c6a0';
        _this.showDetail = new EventEmitter();
        return _this;
    }
    VisitorTourCardComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
    };
    VisitorTourCardComponent.prototype.showTourDetail = function ($event) {
        this.showLoading();
        $event.stopPropagation();
        this.showDetail.emit(this.tour);
    };
    VisitorTourCardComponent.prototype.mouseEnter = function () {
        this.isShowDescription = true;
    };
    VisitorTourCardComponent.prototype.mouseLeave = function () {
        this.isShowDescription = false;
        // / setTimeout(() => {
        //     this.isShowDescription = false;
        // }, 500);
    };
    VisitorTourCardComponent.prototype.showLoading = function () {
        var _this = this;
        this.isLoading = true;
        setTimeout(function () {
            _this.isLoading = false;
        }, 2000);
    };
    return VisitorTourCardComponent;
}(BaseComponent));
export { VisitorTourCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/tour.card/visitor.tour.card.component.ts.pre-build-optimizer.js